export const API_BASE_URL = (
  process.env.REACT_APP_API_URL || 'http://localhost:8003'
).replace(/\/$/, '');

export function apiUrl(path) {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
}

export function apiUnreachableMessage() {
  return `Cannot connect to the API server. Make sure the backend is running at ${API_BASE_URL}`;
}
